import { createLogger } from '@svs/nova-core/log';

import type { DrawStateClient } from '../../../../schema/draw/entry.js';
import {
  DefinitionEntity,
  type IDrawSubscriptionService,
  type ISubscribeDrawForecastUseCase,
} from '../../../domain/entry.js';

const logger = createLogger('poolbetting.drawforecast-application');
const FORECAST_STATES: Set<DrawStateClient> = new Set(['Live', 'Finished']);

/**
 * Use case for retrieving the result of a specific draw.
 *
 * @param drawSubscriptionService - The service to interact with draw subscriptions.
 * @returns Draw result data
 */
export function subscribeDrawForecastUseCase(
  drawSubscriptionService: IDrawSubscriptionService
): ISubscribeDrawForecastUseCase {
  return {
    execute: ({ product, drawNumber, onUpdate }): ReturnType<ISubscribeDrawForecastUseCase['execute']> => {
      const cachedDrawData = drawSubscriptionService.getDrawCache(product, { drawNumber });

      if (
        cachedDrawData?.draw.drawState.client &&
        !DefinitionEntity.hasDrawForecast(cachedDrawData.draw.drawState.client)
      ) {
        logger.debug('Draw not in state for forecast data', {
          product,
          drawNumber,
          drawState: cachedDrawData.draw.drawState.client,
          requiredStates: Array.from(FORECAST_STATES),
        });
      }

      const unsubscribe = drawSubscriptionService.subscribeDrawForecast(product, { drawNumber }, onUpdate);

      return unsubscribe;
    },
  };
}
